import React from 'react';

import {
	Typography,
	TypographyAppearance,
	TypographyColorToken,
	TypographyStyles,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Link } from '@components';
import { rem } from '@helpers';

interface TypographyProps {
	text: string;
	appearance?: TypographyAppearance;
	colorToken?: TypographyColorToken;
	styles?: TypographyStyles;
}

interface LinkProps extends TypographyProps {
	url: string;
	targetType?: 'tab' | 'popup';
}

interface ComposableTextLinkProps {
	typography: TypographyProps;
	link: LinkProps;
}

export const ComposableTextLink: React.FC<ComposableTextLinkProps> = (props) => {
	const {
		typography,
		link,
		link: { targetType = 'tab' },
	} = props;

	return (
		<div>
			<Typography
				appearance={typography.appearance}
				colorToken={typography.colorToken}
				styles={{ marginRight: rem(5), ...typography.styles }}
			>
				{typography.text}
			</Typography>
			<Link targetType={targetType} redirectUrl={link.url} target={'_blank'}>
				<Typography appearance={link.appearance} colorToken={link.colorToken} styles={link.styles}>
					{link.text}
				</Typography>
			</Link>
		</div>
	);
};
